import { BigNumber } from "@yjsgames/bignumber";
import {
  computeProjectileDamage,
  type ProjectileSpec,
} from "../models/ProjectileSpec.js";
import { resolveFireCount } from "./projectileCount.js";

/**
 * 현재 스펙·발사 간격 기준 DPS 추정 (HUD 표시용 순수 계산).
 * perHit(스펙 1회 피해) × (발사체 수 × 확산 타겟 추정 × 초당 발사 수).
 * 확산 타겟 = 1 + 연쇄 + (폭발 시 2) + 관통×0.5 + 분열×0.5 (대략적 동시 타격 수).
 * Phaser 비의존 — fireIntervalMs를 인자로 받아 순수성 확보(단위테스트 가능).
 */
export function estimateDps(
  spec: ProjectileSpec,
  fireIntervalMs: number,
): BigNumber {
  const perHit = computeProjectileDamage(spec);
  const count = resolveFireCount(spec.count); // SSoT — 실제 발사 수(ProjectileFactory)와 동일 floor+clamp
  const firesPerSec = 1000 / fireIntervalMs;
  const spreadTargets =
    1 +
    spec.chainCount +
    (spec.explosionRadius > 0 ? 2 : 0) +
    spec.pierceCount * 0.5 +
    spec.splitCount * 0.5;
  return perHit.mul(BigNumber.fromNumber(count * spreadTargets * firesPerSec));
}
